// src/graphql/mutations/companyMutations.js

export const createCompany = `mutation CreateCompany($input: CreateCompanyInput!) {
    createCompany(input: $input) {
        success
        message
        company {
            id
            name
            size
            industry
            location {
                address
                city
                state
                postalCode
                country
                nutsCode
                latitude
                longitude
            }
        }
        error
    }
}`;

export const updateCompany = `mutation UpdateCompany($id: String!, $input: UpdateCompanyInput!) {
    updateCompany(id: $id, input: $input) {
        success
        message
        company {
            id
            name
            size
            industry
            location {
                address
                city
                state
                postalCode
                country
                nutsCode
                latitude
                longitude
            }
            active
        }
        error
    }
}`;

export const adminUpdateCompany = `mutation AdminUpdateCompany($id: String!, $input: UpdateCompanyInput!) {
    adminUpdateCompany(id: $id, input: $input) {
        success
        message
        company {
            id
            name
            size
            industry
            location {
                address
                city
                state
                postalCode
                country
                nutsCode
                latitude
                longitude
            }
            active
        }
        error
    }
}`;

export const deleteCompany = `mutation DeleteCompany($id: String!) {
    deleteCompany(id: $id) {
        success
        message
        error
    }
}`;

// Fingerprint mutations
export const createCompanyFingerprint = `mutation CreateCompanyFingerprint($companyId: String!, $input: CompanyFingerprintInput!) {
    createCompanyFingerprint(companyId: $companyId, input: $input) {
        success
        message
        fingerprint {
            id
            companyId
            profileName
            isActive
            description
            primaryServices
            technicalSkills
            domainExpertise
            certifications
            languages
            cpvCodes
            nutsCodes
            createdAt
            updatedAt
        }
        error
    }
}`;

export const updateCompanyFingerprint = `mutation UpdateCompanyFingerprint($id: String!, $input: CompanyFingerprintInput!) {
    updateCompanyFingerprint(id: $id, input: $input) {
        success
        message
        fingerprint {
            id
            companyId
            profileName
            isActive
            description
            primaryServices
            technicalSkills
            domainExpertise
            certifications
            languages
            cpvCodes
            nutsCodes
            createdAt
            updatedAt
        }
        error
    }
}`;

export const deleteCompanyFingerprint = `mutation DeleteCompanyFingerprint($id: String!) {
    deleteCompanyFingerprint(id: $id) {
        success
        message
        error
    }
}`;

export const generateFingerprintFromDescription = `mutation GenerateFingerprintFromDescription($description: String!) {
    generateFingerprintFromDescription(description: $description) {
        success
        message
        fingerprint {
            id
            companyId
            profileName
            isActive
            description
            primaryServices
            technicalSkills
            domainExpertise
            certifications
            languages
            cpvCodes
            nutsCodes
            growthAreas
            avoidAreas
            competitiveAdvantages
            createdAt
            updatedAt
        }
        error
    }
}`;
